<template>
    <div class="test-list">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item>用户任务列表(谨慎修改)</el-breadcrumb-item>
        </el-breadcrumb>
        <div class="search">
            <div> <el-button type="success" size="small" @click.native="clickAdd">添加数据</el-button></div>
        </div>
        <div class="list">
            <el-table :data="userTaskList" ref="userTaskList" style="width: 100%" :row-class-name="tableRowClassName"
                size="mini" stripe>
                <el-table-column prop="page_name" label="训练&测验名称"></el-table-column>
                <el-table-column prop="days" label="任务天数" width="80"></el-table-column>
                <el-table-column prop="click_time" label="点击时间"></el-table-column>
                <el-table-column prop="e_time" label="修改时间"></el-table-column>
                <el-table-column prop="scheduled_time" label="任务时间"></el-table-column>
                <el-table-column prop="completed" label="是否完成">
                    <template slot-scope="scope">
                        {{ scope.row.completed ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column prop="today_task_completed" label="今天是否全部完成">
                    <template slot-scope="scope">
                        {{ scope.row.today_task_completed ? '是' : '否' }}
                    </template>
                </el-table-column>
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-edit" circle
                            @click="clickEdit(scope.$index, scope.row)"></el-button>
                        <el-button type="danger" icon="el-icon-delete" circle
                            @click="clickDelete(scope.$index, scope.row)"></el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="block" v-if="false">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pages"
                :page-sizes="[10, 20, 30, 40]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <el-dialog title="提示" :visible.sync="dialogDelete" width="30%" center>
            <div style="text-align: center;font-size: 25px;">是否删除这条数据</div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogDelete = false">取 消</el-button>
                <el-button type="danger" @click="delTaskList">删 除</el-button>
            </span>
        </el-dialog>
        <el-dialog title="修改数据" :visible.sync="dialogModifyData">
            <el-form :model="modifyData" :rules="rules" ref="modifyData">
                <el-form-item label="类别ID" :label-width="formLabelWidth" prop="category.id">
                    <el-input v-model="modifyData.category.id" autocomplete="off" placeholder="请输入类别ID"></el-input>
                </el-form-item>
                <el-form-item label="任务名称" :label-width="formLabelWidth" prop="task_name">
                    <el-input v-model="modifyData.task_name" autocomplete="off" placeholder="请输入任务名称"></el-input>
                </el-form-item>
                <el-form-item label="第几天任务开始" :label-width="formLabelWidth" prop="day">
                    <el-input v-model="modifyData.day" autocomplete="off" placeholder="请输入任务开始的天数"></el-input>
                </el-form-item>
                <el-form-item label="任务描述" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.description" autocomplete="off" placeholder="请输入任务描述"></el-input>
                </el-form-item>
                <el-form-item label="任务id" :label-width="formLabelWidth">
                    <el-input v-model="modifyData.id" autocomplete="off" placeholder="请输入任务id"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogModify">取 消</el-button>
                <el-button type="primary" @click="submitFormModify">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="添加数据" :visible.sync="dialogAddData" width="80%" top="6vh" center @close="closeDialogAdd">
            <div class="search">
                <div>
                    <el-input placeholder="请输入内容" prefix-icon="el-icon-search" size="small"
                        v-model="mobileKey"></el-input>
                </div>
                <div style="margin-right:20px;">
                    <el-select v-model="roomType" placeholder="房间类型" size="small" clearable>
                        <el-option label="脑" value="脑"></el-option>
                        <el-option label="身" value="身"></el-option>
                        <el-option label="食" value="食"></el-option>
                        <el-option label="心" value="心"></el-option>
                    </el-select>
                </div>
                <div> <el-button type="primary" size="small" @click.native="QueryZY">查询</el-button></div>
                <div style="margin-left:20px;"> <el-button type="success" size="small"
                        @click.native="resettingZY">重置</el-button>
                </div>
            </div>
            <div class="list" style="min-height: 100px;">
                <el-table :data="taskListZY" style="width: 100%" :row-class-name="tableRowClassName" size="mini"
                    max-height="300" stripe>
                    <el-table-column prop="id" label="资源id" fixed="left" width="70"></el-table-column>
                    <el-table-column prop="room" label="资源分类"></el-table-column>
                    <el-table-column prop="page_name" label="资源名称"></el-table-column>
                    <el-table-column prop="page_id" label="小程序id"></el-table-column>
                    <el-table-column prop="duration" label="时长"></el-table-column>
                    <el-table-column prop="type" label="资源类型"></el-table-column>
                    <el-table-column prop="difficulty_level" label="训练的难度等级"></el-table-column>
                    <el-table-column prop="db_table" label="数据对应表名"></el-table-column>
                    <el-table-column prop="is_test" label="是否为测试资源"></el-table-column>
                    <el-table-column prop="page_id" label="是否为测试资源"></el-table-column>
                    <el-table-column fixed="right" label="操作" width="150">
                        <template slot-scope="scope">
                            <el-button type="primary" @click="copyContent(scope.$index, scope.row)">选择</el-button>
                        </template>
                    </el-table-column>
                </el-table>
                <div class="block">
                    <el-pagination @size-change="handleSizeChangeZY" @current-change="handleCurrentChangeZY"
                        :current-page="pagesZY" :page-sizes="[10, 20, 30, 40]" :page-size="limitZY"
                        layout="total, sizes, prev, pager, next, jumper" :total="totalZY">
                    </el-pagination>
                </div>
            </div>
            <el-form :model="addData" :rules="rules" ref="addData">
                <el-form-item label="资源ID" :label-width="formLabelWidth" prop="category_id">
                    <el-input v-model="addData.category_id" autocomplete="off" placeholder="请输入类别ID"></el-input>
                </el-form-item>
                <el-form-item label="任务时间" :label-width="formLabelWidth" prop="scheduled_time">
                    <el-date-picker v-model="addData.scheduled_time" type="date" placeholder="请选择任务日期" clearable
                        @change="handleDateChange">
                    </el-date-picker>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="closeDialogAdd">取 消</el-button>
                <el-button type="primary" @click="submitFormAdd">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>


<script>
export default {
    data() {
        return {
            pickerOptions: {
                disabledDate(time) {
                    return time.getTime() > Date.now();
                },
            },
            mobileKey: '',
            pages: 1,
            limit: 10,
            userTaskList: [],
            total: 0,
            dialogDelete: false,
            clickObject: {},
            dialogModifyData: false,
            modifyData: {
                category: {
                    id: ''
                },
                task_name: '',
                day: '',
                description: '',
                task_id: '',
            },
            formLabelWidth: '150px',
            dialogAddData: false,
            addData: {
                user_id: +this.$route.query.user_id,
                category_id: '',
                scheduled_time: '',
            },
            rules: {
                category_id: [
                    { required: true, message: '类别id为必填项', trigger: 'change' }
                ],
                scheduled_time: [
                    { required: true, message: '任务时间为必填项', trigger: 'blur' }
                ],
            },
            delData: {},
            pagesZY: 1,
            limitZY: 10,
            mobileKey: '',
            roomType: '',
            taskListZY: [],
            totalZY: 0,
            day: '', // 搜索任务开始天数
            task_name: '', // 搜索任务名称
            taskList1: [], // 筛选第一列数据
            isStatistics: false, // 是否展示统计数据
        }
    },
    created() {
        this.getTaskList()
    },
    methods: {
        getTaskListZY() {
            this.$get(`/v1/admin/category_table?&pages=${this.pagesZY}&limit=${this.limitZY}&key=${this.mobileKey}&room=${this.roomType}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data)
                    this.taskListZY = res.data.data.data
                    this.totalZY = res.data.total

                    console.log(this.taskListZY, '资源表')
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        tableRowClassName({ row, rowIndex }) {
            if (rowIndex % 2 === 1) {
                return '';
            } else {
                return 'success-row';
            }
        },
        getTaskList() {
            this.$get(`/v1/admin/family?user_id=${this.$route.query.user_id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    console.log(res.data.tasks)
                    let resData = res.data.tasks
                    this.userTaskList = resData
                    console.log(this.userTaskList, '接口返回表')
                    // this.total = res.data.total
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        handleSizeChange(val) {
            console.log(val)
            this.limit = val;
            this.getTaskList()
        },
        handleCurrentChange(val) {
            this.pages = val;
            this.getTaskList()
        },
        handleSizeChangeZY(val) {
            console.log(val)
            this.limitZY = val;
            this.getTaskListZY()
        },
        handleCurrentChangeZY(val) {
            this.pagesZY = val;
            this.getTaskListZY()
        },
        clickEdit(index, row) {
            console.log(index, row);
            this.modifyData = row
            this.dialogModifyData = true
        },
        clickDelete(index, row) {
            console.log(index, row);
            this.dialogDelete = true
            this.delData = row
            console.log(this.delData, '00000000000000')
        },
        // 删除
        delTaskList() {
            this.$delete(`/v1/admin/family?id=${this.delData.id}`, {}).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('删除成功')
                    this.getTaskList()
                } else {
                    this.$msg(res.data.msg)
                }
            });
            this.dialogDelete = false
        },
        clickAdd() {
            this.dialogAddData = true
            this.getTaskListZY()
        },
        submitFormAdd() {
            this.$refs.addData.validate((valid) => {
                if (valid) {
                    this.addTaskList(this.addData)
                } else {
                    this.$message.error('表单验证失败!')
                    return false;
                }
            });
        },
        // 添加
        addTaskList(data) {
            let idList = [...new Set(data.category_id.split(","))];
            let newAddData = {
                category_id: '',
                scheduled_time: data.scheduled_time,
                user_id: +this.$route.query.user_id // 假设存在 user_id，保留它
            };
            console.log(data, newAddData, '添加------------')
            const callApiRecursively = (index) => {
                if (index >= idList.length) {
                    // 所有调用完成，清空数据
                    this.addData = newAddData;
                    this.getTaskList();
                    return;
                }

                let currentId = idList[index];
                let newData = { ...data, category_id: +currentId,user_id: +this.$route.query.user_id  };

                this.$post('/v1/admin/family', newData).then((res) => {
                    if (res.data.status === 'success') {
                        if (index === idList.length - 1) {
                            this.$message.success('添加成功');
                            let obj = {
                                category_id: '',
                                scheduled_time: '',
                            }
                            this.addData = obj
                            this.dialogAddData = false;
                        }
                        // 递归调用下一个 id
                        callApiRecursively(index + 1);
                    } else {
                        this.$msg(res.data.msg);
                    }
                }).catch((error) => {
                    console.error('接口调用出错:', error);
                    this.$msg('接口调用出错，请稍后重试');
                });
            };

            // 开始第一次调用
            callApiRecursively(0);
        },
        closeDialogAdd() {
            this.dialogAddData = false;
            let obj = {
                category_id: '',
                scheduled_time: '',
            }
            this.addData = obj
            this.mobileKey = ''
            this.roomType = ''
        },
        closeDialogModify() {
            this.dialogModifyData = false;
            this.modifyData = {
                category: {
                    id: ''
                },
                task_name: '',
                day: '',
                description: '',
                task_id: '',
            }
        },
        submitFormModify() {
            this.$refs.modifyData.validate((valid) => {
                if (valid) {
                    this.modifyTaskList()
                } else {
                    console.log('表单验证失败!');
                    return false;
                }
            });
        },
        // 修改
        modifyTaskList() {
            this.modifyData.category_id = +this.modifyData.category.id
            this.modifyData.day = +this.modifyData.day
            this.modifyData.task_id = +this.modifyData.id
            console.log('valid', this.modifyData)
            this.$put('/v1/task_table', this.modifyData).then((res) => {
                if (res.data.status === 'success') {
                    this.$message.success('修改成功')
                    this.getTaskList()
                    this.dialogModifyData = false;
                } else {
                    this.$msg(res.data.msg)
                }
            });
        },
        resettingZY() {
            this.mobileKey = this.roomType = ''
            this.getTaskListZY();
        },
        QueryZY() {
            this.pages = 1;
            this.getTaskListZY();
        },
        // 选择
        copyContent(index, row) {
            if (this.addData.category_id === '') {
                this.addData.category_id = `${row.id}`;
            } else {
                this.addData.category_id = `${this.addData.category_id},${row.id}`;
            }
        },
        resetting() {
            this.day = this.task_name = ''
            this.getTaskList();
        },
        Query() {
            this.pages = 1;
            this.getTaskList();
        },
        resetFilters() {
            this.isStatistics = false
            this.$refs.taskList.clearFilter();
            this.$refs.taskList1.clearFilter();
        },
        handleDateChange(value) {
            // 用户选择日期后触发的方法
            const year = value.getFullYear();
            const month = value.getMonth() + 1; // 月份是从0开始的，所以需要加1
            const day = value.getDate();
            const selectedDate = `${year}-${month < 10 ? '0' : ''}${month}-${day < 10 ? '0' : ''}${day}`;
            this.addData.scheduled_time = selectedDate
            console.log(this.addData.scheduled_time)
        },
    }
}
</script>

<style lang="stylus" rel="stylesheet/stylus">
   .el-select .el-input {
      width: 200px;
    }
  .test-list
      .el-table .warning-row {
        background: oldlace;
      }
  
      .el-table .success-row {
        background: #f0f9eb;
      }
  
      .search
        margin 20px 0
        display flex
        justify-content flex-start
        input
          width 200px
          margin-right 20px
        .add
          padding-left 100px
  
      .list
        min-height 550px
        border 1px solid #EBEEF5
        .edit_icon
          width 20px
          height 20px
          margin-left 16px
          border 1px solid  #ccc
          border-radius 4px
  
  </style>


// WEBPACK FOOTER //
// src/pages/UserManage/userTaskPage.vue